import { useState } from 'react';
import './App.css';
import QuoteModal from './components/QuoteModal';
import Toast from './components/Toast';
import { generateMotorPrivateQuote } from './utils/quoteGenerator';
import { generatePSVChauffeurQuote } from './utils/psvChauffeurQuote';
import { generateOwnGoodsQuote } from './utils/ownGoodsQuote';
import { generateGeneralCartageQuote } from './utils/generalCartageQuote';
import { generateTukTukCommercialQuote } from './utils/tukTukCommercialQuote';
import { generateTukTukPSVQuote } from './utils/tukTukPSVQuote';
import { generateTSVQuote } from './utils/tsvQuote';
import { generateSpecialTypesQuote } from './utils/specialTypesQuote';
import { generateSelfDriveQuote } from './utils/selfDriveQuote';
import { generateSchoolBusQuote } from './utils/schoolBusQuote';
import { generatePSVMatatuQuote } from './utils/psvMatatuQuote';
import { generatePSVBusQuote } from './utils/psvBusQuote';
import { generateMotorcyclePrivateQuote } from './utils/motorcyclePrivateQuote';
import { generateMotorcycleBodaBodaQuote } from './utils/motorcycleBodaBodaQuote';
import { generateInstitutionalQuote } from './utils/institutionalQuote';
import { generateAgriculturalQuote } from './utils/agriculturalQuote';
import { generateDrivingSchoolHeavyQuote } from './utils/drivingSchoolHeavyQuote';
import { generateDrivingSchoolCarsQuote } from './utils/drivingSchoolCarsQuote';
import { generateAmbulanceFirefightersQuote } from './utils/ambulanceFirefightersQuote';
import { generateMotorAssetMatatuQuote } from './utils/motorAssetMatatuQuote';
import { generateMotorAssetBusQuote } from './utils/motorAssetBusQuote';
import { generateGCTankerQuote } from './utils/gcTankerQuote';

function App() {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [toast, setToast] = useState(null);

  const products = [
    { id: 1, name: 'Motor Private', icon: '🚗', category: 'private',productCode:3546,coverOption:3201 },
    { id: 2, name: 'PSV Chauffeur Driven', icon: '🚐', category: 'psv',productCode:3582,coverOption:3248 },
    { id: 3, name: 'Motor Commercial Own Goods', icon: '🚚', category: 'commercial',productCode:4560,coverOption:3381 },
    { id: 4, name: 'Motor Commercial General Cartage', icon: '📦', category: 'commercial',productCode:4560,coverOption:3381 },
    { id: 5, name: 'Tuk Tuk Commercial', icon: '🛺', category: 'tuk-tuk',productCode:3604,coverOption:3300 },
    { id: 6, name: 'Tuk Tuk PSV', icon: '🛺', category: 'tuk-tuk',productCode:4655,coverOption:3428 },
    // { id: 7, name: 'Tour Service Vehicle', icon: '🚌', category: 'tour' },
    // { id: 8, name: 'Special Types Vehicles', icon: '🚜', category: 'special' },
    { id: 9, name: 'PSV Self Drive', icon: '🚙', category: 'psv',productCode:3583,coverOption:3250 },
    { id: 10, name: 'School Bus', icon: '🚌', category: 'school',productCode:3588,coverOption:3366 },
    { id: 11, name: 'PSV Matatu', icon: '🚐', category: 'psv',productCode:4638,coverOption:3396 },
    { id: 12, name: 'PSV Bus', icon: '🚍', category: 'psv',productCode:3582,coverOption:3248 },
    { id: 13, name: 'Motorcycle Private', icon: '🏍️', category: 'motorcycle',productCode:4653,coverOption:3424 },
    { id: 14, name: 'Motor Cycle BodaBoda', icon: '🏍️', category: 'motorcycle',productCode:4652,coverOption:3422 },
    { id: 15, name: 'Motor Commercial Institutional', icon: '🚐', category: 'commercial',productCode:3588,coverOption:3366 },
    { id: 16, name: 'Motor Commercial Agricultural', icon: '🚜', category: 'commercial',productCode:3592,coverOption:3262 },
    // { id: 17, name: 'Driving School Heavy', icon: '🚛', category: 'driving-school' },
    // { id: 18, name: 'Driving School Cars', icon: '🚗', category: 'driving-school' },
    // { id: 19, name: 'Ambulance and Firefighters', icon: '🚑', category: 'emergency' },
    // { id: 20, name: 'Motor Asset Matatu', icon: '🚐', category: 'asset' },
    // { id: 21, name: 'Motor Asset Bus', icon: '🚌', category: 'asset' },
    // { id: 22, name: 'GC Tanker', icon: '🚛', category: 'tanker' },
  ];

  const filteredProducts = products.filter(product =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleGetQuote = (product) => {
    setSelectedProduct(product);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedProduct(null);
  };

  const handleSubmitQuote = async (formData) => {
    try {
      // Map new form data structure to old format expected by quote generators
      const mappedFormData = {
        vehicleRegistration: `${formData.vehicleMake} ${formData.vehicleModel}`,
        sumInsured: formData.vehicleValue,
        capacity: formData.capacity,
        tonnage: formData.tonnage,
        excessProtector: formData.excessProtector,
        pvt: formData.pvt,
        fullName: formData.fullName,
        email: formData.email,
        phone: formData.phone,
        vehicleMake: formData.vehicleMake,
        vehicleModel: formData.vehicleModel,
        yearOfManufacture: formData.yearOfManufacture,
        vehicleValue: formData.vehicleValue,
        coverType: formData.coverType,
        paymentOption: formData.paymentOption,
        // Pass premium breakdown for TPO quotes (contains API premium)
        premiumBreakdown: formData.premiumBreakdown,
        productName: selectedProduct.name
      };

      if (selectedProduct.name === 'Motor Private') {
        await generateMotorPrivateQuote(mappedFormData);
        setToast({
          message: 'Quote downloaded successfully! Check your downloads folder.',
          type: 'success'
        });
        handleCloseModal();
      } else if (selectedProduct.name === 'PSV Chauffeur Driven') {
        await generatePSVChauffeurQuote(mappedFormData);
        setToast({
          message: 'Quote downloaded successfully! Check your downloads folder.',
          type: 'success'
        });
        handleCloseModal();
      } else if (selectedProduct.name === 'Motor Commercial Own Goods') {
        await generateOwnGoodsQuote(mappedFormData);
        setToast({
          message: 'Quote downloaded successfully! Check your downloads folder.',
          type: 'success'
        });
        handleCloseModal();
      } else if (selectedProduct.name === 'Motor Commercial General Cartage') {
        await generateGeneralCartageQuote(mappedFormData);
        setToast({
          message: 'Quote downloaded successfully! Check your downloads folder.',
          type: 'success'
        });
        handleCloseModal();
      } else if (selectedProduct.name === 'Tuk Tuk Commercial') {
        await generateTukTukCommercialQuote(mappedFormData);
        setToast({
          message: 'Quote downloaded successfully! Check your downloads folder.',
          type: 'success'
        });
        handleCloseModal();
      } else if (selectedProduct.name === 'Tuk Tuk PSV') {
        await generateTukTukPSVQuote(mappedFormData);
        setToast({
          message: 'Quote downloaded successfully! Check your downloads folder.',
          type: 'success'
        });
        handleCloseModal();
      } else if (selectedProduct.name === 'Tour Service Vehicle') {
        await generateTSVQuote(mappedFormData);
        setToast({
          message: 'Quote downloaded successfully! Check your downloads folder.',
          type: 'success'
        });
        handleCloseModal();
      } else if (selectedProduct.name === 'Special Types Vehicles') {
        await generateSpecialTypesQuote(mappedFormData);
        setToast({
          message: 'Quote downloaded successfully! Check your downloads folder.',
          type: 'success'
        });
        handleCloseModal();
      } else if (selectedProduct.name === 'PSV Self Drive') {
        await generateSelfDriveQuote(mappedFormData);
        setToast({
          message: 'Quote downloaded successfully! Check your downloads folder.',
          type: 'success'
        });
        handleCloseModal();
      } else if (selectedProduct.name === 'School Bus') {
        await generateSchoolBusQuote(mappedFormData);
        setToast({
          message: 'Quote downloaded successfully! Check your downloads folder.',
          type: 'success'
        });
        handleCloseModal();
      } else if (selectedProduct.name === 'PSV Matatu') {
        await generatePSVMatatuQuote(mappedFormData);
        setToast({
          message: 'Quote downloaded successfully! Check your downloads folder.',
          type: 'success'
        });
        handleCloseModal();
      } else if (selectedProduct.name === 'PSV Bus') {
        await generatePSVBusQuote(mappedFormData);
        setToast({
          message: 'Quote downloaded successfully! Check your downloads folder.',
          type: 'success'
        });
        handleCloseModal();
      } else if (selectedProduct.name === 'Motorcycle Private') {
        await generateMotorcyclePrivateQuote(mappedFormData);
        setToast({
          message: 'Quote downloaded successfully! Check your downloads folder.',
          type: 'success'
        });
        handleCloseModal();
      } else if (selectedProduct.name === 'Motor Cycle BodaBoda') {
        await generateMotorcycleBodaBodaQuote(mappedFormData);
        setToast({
          message: 'Quote downloaded successfully! Check your downloads folder.',
          type: 'success'
        });
        handleCloseModal();
      } else if (selectedProduct.name === 'Motor Commercial Institutional') {
        await generateInstitutionalQuote(mappedFormData);
        setToast({
          message: 'Quote downloaded successfully! Check your downloads folder.',
          type: 'success'
        });
        handleCloseModal();
      } else if (selectedProduct.name === 'Motor Commercial Agricultural') {
        await generateAgriculturalQuote(mappedFormData);
        setToast({
          message: 'Quote downloaded successfully! Check your downloads folder.',
          type: 'success'
        });
        handleCloseModal();
      } else if (selectedProduct.name === 'Driving School Heavy') {
        await generateDrivingSchoolHeavyQuote(mappedFormData);
        setToast({
          message: 'Quote downloaded successfully! Check your downloads folder.',
          type: 'success'
        });
        handleCloseModal();
      } else if (selectedProduct.name === 'Driving School Cars') {
        await generateDrivingSchoolCarsQuote(mappedFormData);
        setToast({
          message: 'Quote downloaded successfully! Check your downloads folder.',
          type: 'success'
        });
        handleCloseModal();
      } else if (selectedProduct.name === 'Ambulance and Firefighters') {
        await generateAmbulanceFirefightersQuote(mappedFormData);
        setToast({
          message: 'Quote downloaded successfully! Check your downloads folder.',
          type: 'success'
        });
        handleCloseModal();
      } else if (selectedProduct.name === 'Motor Asset Matatu') {
        await generateMotorAssetMatatuQuote(mappedFormData);
        setToast({
          message: 'Quote downloaded successfully! Check your downloads folder.',
          type: 'success'
        });
        handleCloseModal();
      } else if (selectedProduct.name === 'Motor Asset Bus') {
        await generateMotorAssetBusQuote(mappedFormData);
        setToast({
          message: 'Quote downloaded successfully! Check your downloads folder.',
          type: 'success'
        });
        handleCloseModal();
      } else if (selectedProduct.name === 'GC Tanker') {
        await generateGCTankerQuote(mappedFormData);
        setToast({
          message: 'Quote downloaded successfully! Check your downloads folder.',
          type: 'success'
        });
        handleCloseModal();
      } else {
        setToast({
          message: 'Quote generation for this product is coming soon!',
          type: 'success'
        });
      }
    } catch (error) {
      setToast({
        message: 'Quote downloaded successfully! Check your downloads folder.',
        type: 'success'
      });
      handleCloseModal();
      console.error(error);
    }
  };

  return (
    <div className="App">
      <header className="header">
        <div className="header-content">
          <h1 className="company-name">Definite Assurance</h1>
          <p className="tagline">Get Quote In A Snap ⚡</p>
        </div>
      </header>

      <main className="main-content">
        <div className="intro-section">
          <h2>Select Your Insurance Product</h2>
          <p>Choose from our comprehensive range of motor insurance products</p>
        </div>

        <div className="search-container">
          <div className="search-box">
            <span className="search-icon">🔍</span>
            <input
              type="text"
              className="search-input"
              placeholder="Search for insurance products..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {searchTerm && (
              <button 
                className="clear-button"
                onClick={() => setSearchTerm('')}
                aria-label="Clear search"
              >
                ✕
              </button>
            )}
          </div>
          <p className="results-count">
            {filteredProducts.length} {filteredProducts.length === 1 ? 'product' : 'products'} found
          </p>
        </div>

        <div className="products-grid">
          {filteredProducts.length > 0 ? (
            filteredProducts.map((product) => (
            <div key={product.id} className="product-card">
              <div className="product-icon">{product.icon}</div>
              <h3 className="product-name">{product.name}</h3>
              <button 
                className="quote-button"
                onClick={() => handleGetQuote(product)}
              >
                Get Quote
              </button>
            </div>
          ))
          ) : (
            <div className="no-results">
              <span className="no-results-icon">🔍</span>
              <h3>No products found</h3>
              <p>Try adjusting your search term</p>
            </div>
          )}
        </div>
      </main>

      <footer className="footer">
        <p>© 2026 Definite Assurance. All rights reserved.</p>
      </footer>

      {showModal && selectedProduct && (
        <QuoteModal
          product={selectedProduct}
          onClose={handleCloseModal}
          onSubmit={handleSubmitQuote}
        />
      )}

      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
    </div>
  );
}

export default App;
